import * as _VimeoPlayer from '@vimeo/player';
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupVimeoPlayer } from '@vimeo/player';

export const VimeoPlayer: any = _rollupVimeoPlayer || _VimeoPlayer;
